<template>
    <div>
        <div class="level">
            <div class="level-left">
                <h2 class="title is-size-5">{{ headline }}</h2>
            </div>
            <div class="level-right">
                <button class="button is-default mr-2" @click.prevent="reset" :disabled="!filtersActive">Nulstil filtre</button>
                <button class="button is-primary" @click.prevent="openModal(null)">Opret</button>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <List
                    v-if="listItemCategories.length > 0"
                    table-classes="table is-fullwidth"
                    :columns="columns"
                    :data="listItemCategories"
                    :page-length="50"
                    :rows-clickable="false"
                    :default-order="{ col: 'name', dir: 'asc' }"
                    :search="search"
                    @search="onSearch"
                >
                    <template slot="column-actions" slot-scope="{ row }">
                        <a class="button is-small" @click.stop="openModal(row)" title="Rediger">
                            <span class="icon">
                                <i class="fas fa-edit"/>
                            </span>
                        </a>
                        <a class="button is-small" @click.stop="openModal(row, 'subcategories')" title="Rediger underkategorier">
                            <span class="icon">
                                <i class="fas fa-list"/>
                            </span>
                        </a>
                    </template>
                </List>
                <span v-else class="list-empty">Ingen kategorier fundet</span>
            </div>
        </div>

        <ItemCategoryModal
            :active="modalOpen"
            :item-category="modalItemCategory"
            @closed="closeModal"
            @updated="updated"
            @created="created"
            @deleted="deleted"
            @subcategories-updated="updateList"
            @open-submodal="openSubModal"
            @edit-subcategories="openSubModal"
            ref="modal"
        />
        <ItemSubCategoryModal
            v-if="subModalOpen"
            :active="subModalOpen"
            :item-category="subModalItemCategory"
            @subcategories-updated="updateList"
            @closed="closeSubModal"
        />
    </div>
</template>

<script>
import InputText from "@/elements/form/InputText";
import FormField from "@/elements/form/FormField";
import List from "@/elements/list";
import ItemCategoryModal from "./components/ItemCategoryModal";
import ItemSubCategoryModal from "./components/ItemSubCategoryModal";
import InputCheckbox from "@/elements/form/InputCheckbox";

export default {
    components: { ItemCategoryModal, List, FormField, InputText, InputCheckbox, ItemSubCategoryModal },
    props: {
        headline: String,
        tab: String,
    },
    data() {
        return {
            listItemCategories: [],
            modalOpen: false,
            subModalOpen: false,
            modalItemCategory: null,
            subModalItemCategory: null,
            search: '',
            columns: [
                {
                    name: 'image',
                    title: 'Billede',
                    sortable: false,
                    searchable: false,
                    width: 10,
                    template: (row) => {
                        if (row.image) {
                            return `<div class="item-category-list-image"><img src="${row.image}" alt="${row.name}" /></div>`
                        }
                        return '<div class="has-text-centered">—</div>'
                    }
                },
                { name: 'name', title: 'Kategori', sortable: true, searchable: true, width: 50 },
                { name: 'created_at', hidden: true },
                {
                    name: 'actions',
                    title: '',
                    sortable: false,
                    searchable: false,
                    classes: () => 'has-text-right',
                    width: '100px'
                },
            ],
        }
    },
    computed: {
        filtersActive() {
            return this.search !== '';
        }
    },
    methods: {
        onSearch(value) {
            this.search = value
            this.updateUrlParams()
        },
        reset() {
            this.search = ''
            this.updateUrlParams()
            this.updateList()
        },
        updateUrlParams() {
            let params = {
                tab: this.tab,
            };

            if (this.search) {
                params.search = this.search
            }

            this.$router.push({ query: params })
        },
        openModal(itemCategory = null, tab = 'details') {
            this.modalItemCategory = itemCategory
            this.modalOpen = true
            this.$refs.modal.activeTab = tab
        },
        openSubModal(itemCategory = null) {
            this.subModalItemCategory = itemCategory
            this.subModalOpen = true
        },
        closeModal() {
            this.modalOpen = false
            this.modalItemCategory = null
        },
        closeSubModal() {
            this.subModalOpen = false
            this.subModalItemCategory = null
        },
        updateList() {
            const params = {
                with: 'localizations,subcategories.localizations.locale,subcategories.subcategories,subcategories.localizations.locale',
            };

            window.axios.get('/api/item-categories', { params })
                .then(({ data }) => {
                    this.listItemCategories = data

                    if (this.modalItemCategory) {
                        this.modalItemCategory = this.listItemCategories.find((item) => item.id === this.modalItemCategory.id)
                    }

                    if (this.subModalItemCategory) {
                        var ole = this.modalItemCategory.subcategories.find((item) => item.id == this.subModalItemCategory.id)
                        this.subModalItemCategory = ole
                        this.subModalOpen = false;
                        this.subModalOpen = true;
                    }
                })
        },
        updated(itemCategory) {
            this.listItemCategories = this.listItemCategories.map((item) => {
                if (item.id === itemCategory.id) {
                    return itemCategory
                }
                return item
            })
            this.closeModal();
        },
        created(itemCategory) {
            this.listItemCategories.push(itemCategory)
            this.modalItemCategory = itemCategory
        },
        deleted(itemCategory) {
            this.listItemCategories = this.listItemCategories.filter((item) => item.id !== itemCategory.id)

            this.closeModal();
        },
    },
    mounted() {
        let params = new URLSearchParams(window.location.search)
        this.search = params.get('search') || ''

        this.updateList()
    },
}
</script>

<style lang="scss">
.item-category-list-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;

    & > img {
        max-height: 30px;
    }
}
</style>

